"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conciergeGetPropertyById = void 0;
const client_1 = require("@apollo/client");
const fragments_graphql_1 = require("../fragments.graphql");
exports.conciergeGetPropertyById = (0, client_1.gql) `
  ${fragments_graphql_1.PROPERTY_FIELDS}
  query conciergeGetPropertyById($id: ID!) {
    conciergeGetPropertyById(id: $id) {
      ...PropertyFields
    }
  }
`;
//# sourceMappingURL=property.graphql.js.map